module.exports = __webpack_public_path__ + "static/wellbeing@large-460a8966d2a83e030fb4840c2eaf00e3.jpg";